export default __webpack_public_path__ + "static/media/Blog-2.1c0f382b.png";